






export default {
  name: "ResponsiveLayout",
  props: {
    mobileComponent: {
      type: [Object, Function],
      required: true,
    },
    desktopComponent: {
      type: [Object, Function],
      required: true,
    },
  },
  computed: {
    currentComponent() {
      return this.$screen.isMobile() ? this.mobileComponent : this.desktopComponent;
    },
  },
};
